import { Download, Send, CreditCard, Landmark, Copy } from "lucide-react";

const TILES = [["Owing", "$6,420.00", ""], ["Overdue", "$1,240.00", "text-red-600"], ["Paid last 30 days", "$18,960.00", "text-emerald-700"], ["Drafts", "2", ""]];
const ROWS = [
  ["INV-0048", "Coastline Homes", "Lot 12 Banksia Cres", "Due 14 Jul", "$1,320.00", "Sent"],
  ["INV-0047", "Barwon Builders", "27 Wattle St", "6 days overdue", "$1,240.00", "Overdue"],
  ["INV-0046", "Bellarine Constructions", "Unit 4/9 Ryrie St", "Paid 2 Jul", "$2,860.00", "Paid · card"],
  ["INV-0045", "Coastline Homes", "Lot 88 Federation Dr", "Paid 30 Jun", "$980.00", "Paid · bank"],
  ["Draft", "Geelong Homes", "3 Pakington St", "Not sent", "$1,045.00", "Draft"],
];
const PILL = {
  Sent: "bg-sky-50 text-sky-700", Overdue: "bg-red-50 text-red-700", Draft: "bg-slate-100 text-slate-600",
  "Paid · card": "bg-emerald-50 text-emerald-700", "Paid · bank": "bg-emerald-50 text-emerald-700",
};

// Mock of the coordinator Invoices tab for the home page.
export const InvoicesBody = () => (
  <div className="space-y-3">
    <div className="grid grid-cols-4 gap-2.5">
      {TILES.map(([l, v, c]) => (
        <div key={l} className="rounded-lg bg-white border border-slate-200 p-3">
          <p className="text-[10px] text-slate-500">{l}</p>
          <p className={`font-mono text-[17px] font-bold mt-1 ${c}`}>{v}</p>
        </div>
      ))}
    </div>
    <div className="rounded-lg bg-white border border-slate-200">
      <div className="px-3 h-10 flex items-center gap-2 border-b border-slate-100">
        <p className="font-display font-bold text-[13px] mr-2">Invoices</p>
        <span className="inline-flex items-center gap-1 text-[10px] rounded-full bg-red-600 text-white px-2.5 py-1 font-semibold"><Send className="w-3 h-3" />Chase all overdue</span>
        <span className="inline-flex items-center gap-1 text-[10px] rounded-full border border-slate-200 px-2.5 py-1 font-semibold"><Download className="w-3 h-3" />Export CSV</span>
      </div>
      {ROWS.map(([n, client, job, due, amt, st]) => (
        <div key={n + job} className="px-3 py-2 flex items-center gap-3 border-b border-slate-100 last:border-0">
          <span className="font-mono text-[11px] font-semibold w-16">{n}</span>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-[12px] truncate">{client}</p>
            <p className="text-[10px] text-slate-500 truncate">{job}</p>
          </div>
          <span className={`text-[10px] w-24 ${st === "Overdue" ? "text-red-600 font-semibold" : "text-slate-500"}`}>{due}</span>
          <span className="font-mono text-[12px] font-bold w-20 text-right">{amt}</span>
          <span className="w-24 flex justify-end"><span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${PILL[st]}`}>{st}</span></span>
        </div>
      ))}
    </div>
  </div>
);

const Line = ({ l, v, b }) => <div className={`flex justify-between text-[12px] ${b ? "font-bold text-[14px] pt-2 border-t border-slate-200" : "text-slate-600"}`}><span>{l}</span><span className="font-mono">{v}</span></div>;

// Mock of the public "View and pay" page the client opens from the invoice email.
export const PayScreen = () => (
  <div className="space-y-3">
    <div className="rounded-xl bg-white border border-slate-200 p-4">
      <p className="text-[11px] text-slate-500">Invoice INV-0048 · Coastline Homes</p>
      <p className="font-mono text-[28px] font-extrabold mt-1">$1,320.00</p>
      <p className="text-[11px] text-slate-500">Due 14 Jul 2026</p>
      <div className="mt-3 h-10 rounded-full bg-[#EA580C] text-white font-bold text-[13px] flex items-center justify-center gap-2"><CreditCard className="w-4 h-4" />Pay by card</div>
    </div>
    <div className="rounded-xl bg-white border border-slate-200 p-4 space-y-2">
      <p className="flex items-center gap-2 font-semibold text-[12px]"><Landmark className="w-4 h-4 text-[#1E3A5F]" />Or pay by bank transfer</p>
      {[["BSB", "063-000"], ["Account", "1234 5678"], ["Reference", "INV-0048"]].map(([k, v]) => (
        <div key={k} className="flex items-center justify-between text-[11px]"><span className="text-slate-500">{k}</span><span className="font-mono font-semibold flex items-center gap-1.5">{v}<Copy className="w-3 h-3 text-slate-400" /></span></div>
      ))}
    </div>
    <div className="rounded-xl bg-white border border-slate-200 p-4 space-y-1.5">
      <Line l="Labour · 12 h × $95" v="$1,140.00" />
      <Line l="Materials" v="$60.00" />
      <Line l="GST" v="$120.00" />
      <Line l="Total" v="$1,320.00" b />
    </div>
  </div>
);
